import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export type BoardPowerUpsContextMemberLocaleFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id'>
  & { prefs?: Types.Maybe<(
    { __typename: 'Member_Prefs' }
    & Pick<Types.Member_Prefs, 'locale'>
  )> }
);

export const BoardPowerUpsContextMemberLocaleFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardPowerUpsContextMemberLocale' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prefs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseBoardPowerUpsContextMemberLocaleFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      BoardPowerUpsContextMemberLocaleFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseBoardPowerUpsContextMemberLocaleFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<BoardPowerUpsContextMemberLocaleFragment>,
    'data'
  > {
  data?: BoardPowerUpsContextMemberLocaleFragment;
}

export const useBoardPowerUpsContextMemberLocaleFragment = ({
  from,
  returnPartialData,
  ...options
}: UseBoardPowerUpsContextMemberLocaleFragmentOptions): UseBoardPowerUpsContextMemberLocaleFragmentResult => {
  const result = Apollo.useFragment<BoardPowerUpsContextMemberLocaleFragment>({
    ...options,
    fragment: BoardPowerUpsContextMemberLocaleFragmentDoc,
    fragmentName: 'BoardPowerUpsContextMemberLocale',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as BoardPowerUpsContextMemberLocaleFragment,
  };
};
